import { rechercheVersLogin } from '@/lib/garde-session';
import { effacerSession } from '@/lib/session';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * The session is no longer accepted: forget it and go to the login page, which says the session
 * expired and brings the user back to this page once signed in (B5, #13).
 */
export function RedirectionLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    effacerSession();
    void navigate({ to: '/login', search: rechercheVersLogin('session-expiree'), replace: true });
  }, [navigate]);

  return null;
}
